// extracted by mini-css-extract-plugin
export default {"spinner":"Loading__spinner--jhhry"};